import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/services", "fr", "services");
